import React from "react";
import { Modal, Form, Typography } from "antd";
import { FormattedMessage } from 'react-intl';

const DeletePersonFromEveryoneConfimModal = Form.create({
  name: "delete_person_from_everyone_confim_modal"
})(
  // eslint-disable-next-line
  class extends React.Component {
    static defaultProps = {
      visible: false,
      maskClosable: false,
      destroyOnClose: true,
      width: 405,
      title: "Delete person",
      okText: "Delete",
      cancelButtonProps: {
        type: "link",
        "data-dfs-people-id":
          "delete-person-from-everyone-confirm-modal-cancel-link"
      },
      okButtonProps: {
        loading: false,
        "data-dfs-people-id":
          "delete-person-from-everyone-confirm-modal-delete-button"
      },
      centered: true,
      onCancel() { },
      onOk() { }
    };

    render() {
      const {
        visible,
        onCancel,
        onCreate,
        maskClosable,
        destroyOnClose,
        width,
        title,
        okText,
        cancelButtonProps,
        okButtonProps,
        centered
      } = this.props;
      return (
        <Modal
          destroyOnClose={destroyOnClose}
          width={width}
          centered={centered}
          maskClosable={maskClosable}
          visible={visible}
          title={title}
          okText={okText}
          cancelButtonProps={cancelButtonProps}
          onCancel={onCancel}
          onOk={onCreate}
          okButtonProps={okButtonProps}
        >
          <Typography.Paragraph>
            <FormattedMessage id="DeletePersonConfirm" defaultMessage="Are you sure you want to delete this?" />
          </Typography.Paragraph>
        </Modal>
      );
    }
  }
);
export default DeletePersonFromEveryoneConfimModal;
